// extracted by css-extract-rspack-plugin
export default {"unClickableRow":"unClickableRow-K1zlul"};